import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'amount'
})
export class AmountPipe implements PipeTransform {
  transform(value: number): number {
    return value / 100;
  }
}